import { render } from "./BreadCrumb.vue?vue&type=template&id=a81c55fc"
import script from "./BreadCrumb.vue?vue&type=script&lang=js"
export * from "./BreadCrumb.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/documentation.probabilityworks.cloud/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__